// extracted by mini-css-extract-plugin
export default {"empty":"EmptyState_empty__HPhnD","icon":"EmptyState_icon__4tZVW","msg":"EmptyState_msg__mdED2","hint":"EmptyState_hint__IyT1y"};